module.exports = __webpack_public_path__ + "img/20-years-badge-BERGET-EVENTS.cc9fdadb.png";